import dayjs from "dayjs";

type Domain = string;
type Trend = Record<string, number>;
interface IData {
    domain: Domain;
    trend?: Trend;
}

const formatTrend = (trendData: Trend) =>
    Object.entries(trendData).map(
        ([dateString, value]) => [dayjs(dateString).unix(), value] satisfies [number, number],
    );

interface ITransformerData<D> {
    data: D[];
    icons?: Record<Domain, string>;
    primaryDomain?: Domain;
}

export interface ITransformedDomain {
    value: string;
    icon: string | null;
    isPrimaryDomain: boolean;
}

export const transformData = <D extends IData>({ data, icons, primaryDomain }: ITransformerData<D>) =>
    data.map(({ domain, trend, ...other }, index) => ({
        ...other,
        domain: {
            value: domain,
            icon: icons?.[domain] ?? null,
            isPrimaryDomain: domain === primaryDomain,
        } satisfies ITransformedDomain,
        rank: index + 1,
        trend: trend && formatTrend(trend),
    }));
